import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import ButtonPrimary from "../../../../components/ButtonPrimary";
import Price from "../../../../components/Price";
import { ModalFooter } from "../../../../components/Modal/ModalFooter";
import { ModalContent } from "../../../../components/Modal/ModalContent";
import { ModalHeader } from "../../../../components/Modal/ModalHeader";
import { IConfirmManualRecycleModalProps } from "./types";
import { getPrice } from "../../../../utils/common";

import "./styles.scss";

export const ConfirmManualRecycleModal: FC<IConfirmManualRecycleModalProps> = ({
  onDismiss,
  onConfirm,
  nextInvoice,
  isLoading,
  ...props
}) => {
  const { t } = useTranslation();

  if (!nextInvoice.nextInvoicesAmount) {
    return null;
  }

  const { amount, currency } = nextInvoice.nextInvoicesAmount;

  return (
    <Modal
      id="confirmation-modal"
      className="ams-confirmation-recycle-modal"
      {...props}
    >
      <ModalHeader>{t("confirmManualRecycleCharges")}</ModalHeader>
      <ModalContent className="ams-confirmation-recycle-modal__content">
        <Trans
          i18nKey="byManuallyRecyclingNow"
          tOptions={{
            price: getPrice(amount, currency),
          }}
        >
          By manually recycling now, you will be charged
          <b>
            <Price amount={amount} currencyCode={currency} />
          </b>
          and a new rotation will begin immediately. Your data usage will be
          reset.
        </Trans>
      </ModalContent>
      <ModalFooter className="mt-2xl">
        <Button
          onClick={onDismiss}
          className="ams-modal__action"
          id="cancel-button"
        >
          {t("cancel")}
        </Button>
        <ButtonPrimary
          onClick={onConfirm}
          className="ams-modal__action"
          id="submit-button"
          isLoading={isLoading}
        >
          {t("manuallyRecycleNow")}
        </ButtonPrimary>
      </ModalFooter>
    </Modal>
  );
};
